module.exports = __webpack_public_path__ + "img/spodoptera-litura.9f6defc9.jpg";